// Storage keys
const KEYS = {
  ACCESS_TOKEN: "glucera_access_token",
  USER_INFO: "glucera_user_info",
};

export const setGluceraAccessToken = (token: string) => {
  localStorage.setItem(KEYS.ACCESS_TOKEN, token);
};

export const getGluceraAccessToken = () => {
  return localStorage.getItem(KEYS.ACCESS_TOKEN);
};

export const setGluceraUserInfo = (user: any) => {
  localStorage.setItem(KEYS.USER_INFO, JSON.stringify(user));
};

export const getGluceraUserInfo = () => {
  const userInfo = localStorage.getItem(KEYS.USER_INFO);
  return userInfo ? JSON.parse(userInfo) : null;
};

export const clearGluceraStorage = () => {
  localStorage.removeItem(KEYS.ACCESS_TOKEN);
  localStorage.removeItem(KEYS.USER_INFO);
};
